import { RegularFlightMedicalComponent } from './../service-type-components/regular-flight-medical/regular-flight-medical.component';
import { ServiceTypeComponent } from './../models/interfaces';
import { ServiceOrderTypeState } from './../models/serviceOrderTypeState';
import {
  CommitmentTypes,
  DefaultCoveragesAlwaysPresentEnum,
  MessageChannelType,
  PatientType,
  ServiceTypeEnum,
  StatusTypes
} from '@secca/shared/models/enums';
import { StakeholderService } from 'src/app/core/services/stakeholder.service';
import { PlanService } from '@secca/core/services/plan.service';
import { AutoUnsubscribe } from 'src/app/shared/decorators/auto-unsubscribe';
import { IncidentService } from '@secca/core/services/incident.service';
import { CaseIncident } from '@secca/shared/models/caseIncident';
import { UntypedFormControl } from '@angular/forms';
import { InputTypePattern, PermissionEnum, StakeholderTypeEnum } from 'src/app/shared/models/enums';
import { CaseStakeholder } from '@secca/shared/models/caseStakeholder';
import { CaseService } from 'src/app/core/services/case.service';
import { AutoCompleteTypeEnum } from 'src/app/shared/components/drop-down-countries-auto-complete/auto-complete-type-enum';
import { DropdownDictionary, SupplierDropDownAdapter } from '@secca/shared/models/dropdownDictionary';
import { Component, effect, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UserDto } from '@secca/shared/models/userDto';
import { DictionaryService } from '@secca/core/services/dictionary.service';
import { SelectionAwareStakeholder } from '@secca/case/components/case-plans/case-plans/add-service-order/models/SelectionAwareStakeholder';
import { CaseCoverageDropDown } from '@secca/shared/models/case-coverage-drop-down';
import { ServiceOrderExtension } from '@secca/shared/models/service-order/service-order-extension';
import { ServiceOrder } from '@secca/shared/models/service-order/service-order';
import { CaseLockHelperService } from '@secca/core/services/case-lock-helper.service';
import { shareReplay, switchMap, take } from 'rxjs/operators';
import { Coverage } from '@secca/shared/models/onepoint-coverage';
import { PermissionService } from '@secca/core/services/permission.service';
import { CaseStateService } from '@secca/core/state-services/case-state.service';
import { ServiceOrderType } from '@secca/shared/models/service-order-type';
import { CaseDialogViewerService } from '@secca/case/case-dialog-viewer.service';
import { DialogStateService } from '@secca/core/state-services/dialog-state.service';
import {
  SupplierDialogData,
  SupplierSearchData
} from '@secca/case/components/case-plans/case-plans/add-service-order/search-service-provider/SupplierDialogData';
import { NgxCurrencyInputMode } from 'ngx-currency';
import { ExchangeRateService } from '@secca/core/services/exchange-rate.service';
import { SupplierProfileService } from '@secca/core/services/supplier-profile.service';
import { ServiceOrderMessageRequest } from '@secca/shared/models/service-order/service-order-message-request';
import { Message } from '@secca/case/components/case-output-management/models/message';
import { Case } from '@secca/shared/models/case';
import { CaseMessageService } from '@secca/core/services/case-message.service';
import { PhoneDto } from '@secca/shared/models/phone-dto';
import { AmbulanceFlightComponent } from '../service-type-components/ambulance-flight/ambulance-flight.component';
import { AccountGopService } from '@secca/core/services/account-gop.service';
import { SuggestionService } from '@secca/core/services/sugguester/suggestion.service';
import {
  ReserveSuggesterDto,
  ReserveSuggestionResponseDto
} from '@secca/case/components/case-plans/case-plans/add-service-order/models/ReserveSuggesterLineDto';
import { TreatmentServiceOrderExtension } from '@secca/shared/models/service-order/treatment-service-order-extension';
import { MedicalEscortServiceOrderExtension } from '@secca/shared/models/service-order/medical-escort-service-order-extension';
import { DurationChangeSignalsService } from '@secca/core/services/sugguester/duration-change-signals.service';
import { SettingsService } from '@secca/core/services/settings.service';
import { CommitmentType } from '@secca/shared/models/commitment-type';
import { forkJoin, Observable, of, Subject } from 'rxjs';
import { MedicalEscortFeeService } from '@secca/core/services/sugguester/medical-escort-fee.service';
import { MedicalEscortFeeResponseDto } from '@secca/case/components/case-plans/case-plans/add-service-order/models/MedicalEscortFeeDto';
import { InsuranceService } from '@secca/core/services/insurance.service';
import { CustomerProfileInfo } from '@secca/shared/models/customerProfileInfo';

const NOT_COVERED_SERVICE_ORDERS = [
    ServiceTypeEnum.TREATMENT,
    ServiceTypeEnum.ACCOMMODATION,
    ServiceTypeEnum.REGULAR_FLIGHT_NON_MEDICAL,
    ServiceTypeEnum.REGULAR_FLIGHT_MEDICAL,
    ServiceTypeEnum.AMBULANCE_FLIGHT,
    ServiceTypeEnum.GROUND_AMBULANCE,
    ServiceTypeEnum.GROUND_TRANSPORT,
    ServiceTypeEnum.HANDLING_OF_MORTAL_REMAINS,
    ServiceTypeEnum.ASSISTANCE_OR_CONTACT,
    ServiceTypeEnum.LUGGAGE,
    ServiceTypeEnum.MONEY_TRANSFER,
    ServiceTypeEnum.OTHER_REFUND_REQUEST,
    ServiceTypeEnum.ADVICE_CALL_REGISTRATION
  ];

@Component({
    selector: 'app-left-side',
    templateUrl: './left-side.component.html',
    styleUrls: ['./left-side.component.scss'],
    standalone: false
})
@AutoUnsubscribe
export class LeftSideComponent implements OnInit, OnDestroy {
  @Input() selectedServiceOrderInitialStatus: StatusTypes;
  @Input() serviceTypeComponent: ServiceTypeComponent;

  @Input() showProviderSpinner = false;

  @Input() set serviceOrderTypeState(serviceOrderTypeState: ServiceOrderTypeState) {
    this._serviceOrderTypeState = serviceOrderTypeState;
    if (this.$subscr1 != null) {
      this.$subscr1.unsubscribe();
    }
    this.$subscr1 = serviceOrderTypeState.confirmationTabHasBeenClosed.subscribe(() => {
      this.changeStatus(StatusTypes.EXPECTED);
    });
  }
  get serviceOrderTypeState() {
    return this._serviceOrderTypeState;
  }
  @Input() set returnedProviders(returnedProviders: CaseStakeholder[]) {
    this._returnedProviders = returnedProviders;
    this.returnedProvidersChanged.next();
    if (this.caseId != null) {
      this.mockProviders(returnedProviders);
    }
  }

  @Input() incidentId: number;
  @Input() serviceOrderType: ServiceOrderType;
  @Input() lastGopDocumentId: string;

  @Input()
  set serviceOrder(serviceOrder: ServiceOrder) {
    this._serviceOrder = serviceOrder;
    this.hasSupplier = !!serviceOrder.supplierId;
    // Make sure that tab is set according to status on incoming service order
    this.changeStatus(this._serviceOrder.status);
    if (
      this._serviceOrder.type === ServiceTypeEnum.REFERRAL_TO_CUSTOMER ||
      this._serviceOrder.type === ServiceTypeEnum.GENERAL_ADVICE ||
      this._serviceOrder.type === ServiceTypeEnum.ADVISE_ON_INSURANCE_TERMS ||
      this._serviceOrder.type === ServiceTypeEnum.ADVICE_CALL_REGISTRATION ||
      this._serviceOrder.type === ServiceTypeEnum.PRE_DEPARTURE_TRAVEL_SERVICE
    ) {
      this.isSupplierDisabled = true;
      this.expectedCostDisabled = true;
      this.expectedNotPossible = true;
      this.serviceOrder.expectedCostValue = '0';
    } else {
      this.isSupplierDisabled = false;
      this.expectedCostDisabled = false;
    }

    if ( this._serviceOrder.type === ServiceTypeEnum.PRE_DEPARTURE_TRAVEL_SERVICE ) {
      this.allowSearchSupplierIgnoreTransfer = true;
    }
  }

  @Input() iccServiceOrder: ServiceOrder;

  private expectedNotPossible = false;

  get serviceOrder() {
    return this._serviceOrder;
  }
  @Output() extensionChange: EventEmitter<ServiceOrderExtension> = new EventEmitter();
  @Output() supplierChange: EventEmitter<number> = new EventEmitter();
  @Output() supplierAddedEvent: EventEmitter<number> = new EventEmitter();
  @Input()
  set caseId(newCaseId: number) {
    if (newCaseId !== undefined) {
      this._caseId = newCaseId;
      if (this.returnedProviders != null) {
        this.mockProviders(this.returnedProviders);
      }
    }
  }

  get caseId(): number {
    return this._caseId;
  }

  @Input()
  set type(newTypeId: number) {
    if (newTypeId !== undefined) {
      this._typeId = newTypeId;
    }
  }

  get type(): number {
    return this._typeId;
  }

  get gopCreated(): boolean {
    return !!this.lastGopDocumentId;
  }

  get supplierDisabled(): boolean {
    return (
      this.serviceOrder.status === StatusTypes.CANCELLED ||
      this.gopCreated ||
      this.isSupplierDisabled ||
      this.serviceOrderTypeState.isLockedByCoordinationTransport ||
        this.showProviderSpinner ||
      (!this.serviceOrderTypeState.canConfirmationTabBeClosed && this.serviceOrder.status !== StatusTypes.EXPECTED && this.hasSupplier)
    );
  }

  expectedCostDisabled = false;
  private caseStakeholders: CaseStakeholder[];

  @Input() set stakeholders(stakeholders: CaseStakeholder[]) {
    this.caseStakeholders = stakeholders;
    if (stakeholders) {
      this.selectionAwareStakeholders = stakeholders.map(stakeholder => new SelectionAwareStakeholder(stakeholder, false));
      this.selectStakeholders();
    }
  }

  @Input() baseCurrenciesSupported: DropdownDictionary[];
  currencyMaskOptions = {
    prefix: '',
    thousands: '.',
    decimal: ',',
    precision: 2,
    allowNegative: false,
    inputMode: NgxCurrencyInputMode.Natural,
  };
  private _serviceOrderTypeState: ServiceOrderTypeState;
  private incident = new CaseIncident();
  private _caseId: number;
  private _returnedProviders: CaseStakeholder[];
  private returnedProvidersChanged = new Subject<void>();
  private caseNumber: string;
  private case: Case;
  private customerProfileInfo$: Observable<CustomerProfileInfo>;
  private loggedInUser: UserDto;
  private uniqueId: string;
  private _typeId: number;
  private lookedUpCurrency: string = null;
  public searchStartLocationFormControl: UntypedFormControl;
  public searchEndLocationFormControl: UntypedFormControl;
  validCaseCoverages: CaseCoverageDropDown[];
  validCaseCoveragesForAdvice: CaseCoverageDropDown[];
  providers: DropdownDictionary[];
  private isSupplierDisabled;
  private hasSupplier: boolean;
  _serviceOrder: ServiceOrder;
  $subscr1;

  selectionAwareStakeholders: SelectionAwareStakeholder[];
  allowSearchSupplierIgnoreTransfer: boolean;
  suggestedReserveValue = 0;
  @Input()
  displayServiceOrderId: string;
  protected reserveSuggestionFeatureEnabled = false;

  get returnedProviders(): CaseStakeholder[] {
    return this._returnedProviders;
  }

  get isRightSideValid(): boolean {
    if (this.serviceTypeComponent == null) {
      return false;
    } else {
      if (RegularFlightMedicalComponent.prototype.isPrototypeOf(this.serviceTypeComponent)) {
        return (this.serviceTypeComponent as RegularFlightMedicalComponent).isValidForChangingTheStatusToConfirmation();
      }

      if (AmbulanceFlightComponent.prototype.isPrototypeOf(this.serviceTypeComponent)) {
        return (this.serviceTypeComponent as AmbulanceFlightComponent).isValidForChangingTheStatusToConfirmation();
      }
      return this.serviceTypeComponent.isValid();
    }
  }

  get isRegularFlightNonMedical(): boolean {
    return this._serviceOrder.type === ServiceTypeEnum.REGULAR_FLIGHT_NON_MEDICAL;
  }

  get isMedicalFlight(): boolean {
    return this._serviceOrder.type === ServiceTypeEnum.AMBULANCE_FLIGHT;
  }

  constructor(
    private planService: PlanService,
    private caseService: CaseService,
    private incidentService: IncidentService,
    private supplierAdapter: SupplierDropDownAdapter,
    private dictionaryService: DictionaryService,
    private stakeholderService: StakeholderService,
    public caseLockHelperService: CaseLockHelperService,
    public permissionService: PermissionService,
    public caseStateService: CaseStateService,
    public settingsService: SettingsService,
    private dialogViewerService: CaseDialogViewerService,
    private exchangeService: ExchangeRateService,
    private supplierProfileService: SupplierProfileService,
    private dialogStateService: DialogStateService,
    private caseMessageService: CaseMessageService,
    private accountGopService: AccountGopService,
    private suggestionService: SuggestionService,
    private readonly insuranceService: InsuranceService,
    private readonly medicalEscortFeeService: MedicalEscortFeeService,
    public durationChangeSignals: DurationChangeSignalsService
  ) {
    effect(() => {
      const currentValue = this.durationChangeSignals.durationChanged();
      this.getAutoSuggestion(currentValue);
    });
  }

  ngOnInit() {
    this.type = 1;
    this.setSeccaCaseNumber();
    this.getAllValidCaseCoverages();
    this.searchStartLocationFormControl = new UntypedFormControl();
    this.searchEndLocationFormControl = new UntypedFormControl();
    this.getLoggedInUser();
    this.selectStakeholders();
    this.getIncident();
    this.checkIfLeftSideIsValid();
    this.reserveSuggestionFeatureEnabled = this.settingsService.isReserveSuggestionEnabled();
  }


  ngOnDestroy(): void {
    this.accountGopService.updateAccountGopInfo('0');
  }

  get reserveAmountRequired(): boolean {
    return this._serviceOrder.type !== ServiceTypeEnum.ADVISE_ON_INSURANCE_TERMS;
  }

  get isNotMedicalEscortServiceOrderType(): boolean {
    return this._serviceOrder.type !== ServiceTypeEnum.MEDICAL_ESCORT && this._serviceOrder.type !== ServiceTypeEnum.OTHER_REFUND_REQUEST;
  }

  get isNotMajorIncidentServiceOrderType(): boolean {
    return this._serviceOrder.type !== ServiceTypeEnum.MAJOR_INCIDENT;
  }

  get isHomeAndPropertyServiceOrderType(): boolean {
    return this._serviceOrder.type === ServiceTypeEnum.HOME_AND_PROPERTY;
  }

  get showReserveCard(): boolean {
    return this.isNotMajorIncidentServiceOrderType && !this.isHomeAndPropertyServiceOrderType;
  }

  get isAdviceStyleCoverage(): boolean {
    return this._serviceOrder.type === ServiceTypeEnum.ADVICE_CALL_REGISTRATION
        || this._serviceOrder.type === ServiceTypeEnum.HOME_AND_PROPERTY;
  }

  showNotCoveredStatus() {
    return NOT_COVERED_SERVICE_ORDERS.includes(this.serviceOrder.type);
  }

  get selectedStakeholders(): CaseStakeholder[] {
    if (this.caseStakeholders == null) {
      return null;
    } else {
      const selectedStakeholders = this.serviceOrder.getSelectedStakeholderIds();
      if (selectedStakeholders) {
        return this.caseStakeholders.filter(stakeholder =>
          selectedStakeholders.includes(stakeholder.id)
        );
      }
      return this.caseStakeholders.filter(stakeholder => stakeholder.hasRole(StakeholderTypeEnum.endUser));
    }
  }

  private getIncident() {
    this.incidentService.getCaseIncident(this.incidentId).subscribe(incident => {
      this.incident = incident;
    });
  }

  private selectStakeholders() {
    if (this.selectionAwareStakeholders !== null && this.selectionAwareStakeholders !== undefined) {
      this.selectionAwareStakeholders.forEach(s => {
        let stakeholderWasAppearingOnServiceOrder = false;
        s.isSelected = stakeholderWasAppearingOnServiceOrder;
      });
      this.serviceOrder.caseStakeholderIds = this.selectionAwareStakeholders.map(a => +a.stakeholder.id);
    }
  }

  private getLoggedInUser() {
    this.dictionaryService.getLoggedInUser().subscribe(result => {
      this.loggedInUser = result;
    });
  }

  private setSeccaCaseNumber() {
    this.caseService.getCase(this._caseId.toString()).subscribe(result => {
      this.case = result;
      this.caseNumber = result.caseNumber;
      this.customerProfileInfo$ = this.insuranceService.getCustomerProfileInfo(this.case.id).pipe(shareReplay(1));
    });
  }

  get InputTypePattern() {
    return InputTypePattern;
  }

  private getAllValidCaseCoverages() {
    this.planService.getValidCaseCoverages(this.caseId).subscribe(result => {
      const resultValidCaseCoverages: Coverage[] = result;
      const numberOfDefaultCoveragesAlwaysPresent = 3;
      // if there are more valid coverages than numberOfDefaultCoveragesAlwaysPresent a product has been chosen
      const isProductSet = resultValidCaseCoverages.length > numberOfDefaultCoveragesAlwaysPresent;

      if (this.serviceOrder.coverageTypeId === DefaultCoveragesAlwaysPresentEnum.UNKNOWN) {
        const coverage = new Coverage();
        coverage.coverageId = DefaultCoveragesAlwaysPresentEnum.UNKNOWN.toString();
        coverage.coverageName = 'Unknown';
        resultValidCaseCoverages.push(coverage);
      }

      this.validCaseCoverages = resultValidCaseCoverages.map(
        value =>
          new CaseCoverageDropDown(
            +value.coverageId,
            value.coverageName,
            this.isCaseCoveragesDisabled(value.coverageId, isProductSet)));


      this.validCaseCoveragesForAdvice = this.validCaseCoverages.map(caseCoverageDropDown => ({ ... caseCoverageDropDown }));

      for (const element of this.validCaseCoveragesForAdvice) {
          if (element.id === DefaultCoveragesAlwaysPresentEnum.NOT_COVERED && isProductSet){
            element.disabled = false;
          }
      }
    });
  }

  private isCaseCoveragesDisabled(coverageId, isProductSet): boolean {
    switch (coverageId) {
      case DefaultCoveragesAlwaysPresentEnum.ACUTE_COMMITTED_BEFORE_POLICY_SELECTION:
        return isProductSet;
      case DefaultCoveragesAlwaysPresentEnum.NOT_COVERED:
        return !isProductSet;
      case DefaultCoveragesAlwaysPresentEnum.UNKNOWN:
        return true;
      default:
        return false;
    }
  }

  mockProviders(result: any[]) {
    if (result != null) {
      this.providers = result
        .filter(
          stakeholder =>
            stakeholder.stakeholderType !== StakeholderTypeEnum.endUser &&
            stakeholder.stakeholderType !== StakeholderTypeEnum.reporter &&
            stakeholder.stakeholderType !== StakeholderTypeEnum.policyHolder &&
            stakeholder.stakeholderType !== StakeholderTypeEnum.person
        )
        .map(data => this.supplierAdapter.adapt(data))
        .map(data => new DropdownDictionary(+data.id, data.name))
        .filter(data => data.name != null)
        .sort((a, b) =>
          a.name === 'Egencia' ||
          a.name === 'Albin International Repatriation Limited' ||
          a.name === 'GET-E International Airport Transfers'
            ? -1 : 0); // Egencia, Albin International Repatriation Limited, GET-E International Airport Transfers top of list
    }
  }

  get AutoCompleteTypeEnum() {
    return AutoCompleteTypeEnum;
  }

  isOddNumber(index: number) {
    if (index % 2 === 0) {
      return true;
    }
    return false;
  }
  supplierChanged(supplierId: number) {
    this.checkIfLeftSideIsValid();
    if (!this.serviceOrder.exchangedCostValue) {
      this.serviceOrder.exchangedCostValue = null;
    }
    this.lookupCreditorCurrency();
    this.supplierChange.emit(supplierId);
    const stakeholder = this.returnedProviders.find(sh => +sh.id === this.serviceOrder.supplierId);

    if (this.serviceOrderType.serviceTypeCode === 'ST01') {
      this.accountGopService.updateAccountGopInfo(stakeholder?.company?.providerId ?? '0');
    }
    this.getAutoSuggestion(stakeholder);
  }

  dataChanged() {
    this.checkIfLeftSideIsValid();
  }

  checkIfLeftSideIsValid() {
    if (this.serviceOrder.coverageTypeId != null &&
          ((this.serviceOrder.expectedCostValue?.length && +this.serviceOrder.expectedCostValue >= 0) || !this.reserveAmountRequired)) {
      this.serviceOrderTypeState.isLeftSideValid = true;
    }
    else if (this.serviceOrder.coverageTypeId != null &&
            (this._serviceOrder.type === ServiceTypeEnum.REFERRAL_TO_CUSTOMER
              || this._serviceOrder.type === ServiceTypeEnum.GENERAL_ADVICE
              || this._serviceOrder.type === ServiceTypeEnum.HOME_AND_PROPERTY)
    ) {
      this.serviceOrderTypeState.isLeftSideValid = true;
    }
    else if (this._serviceOrder.type === ServiceTypeEnum.MAJOR_INCIDENT) {
      this.serviceOrderTypeState.isLeftSideValid = true;
    }
    else {
      this.serviceOrderTypeState.isLeftSideValid = false;
    }
    this.serviceOrderTypeState.isSupplierChosen = this.serviceOrder.supplierId != null;
  }

  viewSupplier() {
    const result = this.returnedProviders.find(stakeholder => +stakeholder.id === this.serviceOrder.supplierId);
    if (!result || !result.company) {
      console.error(`No stakeholder with id: ${this.serviceOrder.supplierId} found or company is null`);
      return;
    }

    const data: SupplierSearchData = {supplierId: +result.company.providerId, caseId: +result.caseId, creditorId: undefined};
    const matDialogRef = this.dialogViewerService.openSupplierSearchDialogFromPlansAddServices(data);
    if ( matDialogRef ) {
      setTimeout(() => {
        this.dialogStateService.sendToFront(matDialogRef.id);
      }, 0);
    }
  }

  searchSupplier() {
    const supplierDialogData = {
      caseId: this.caseId,
      serviceOrder: this.serviceOrder,
      suppliers: this.returnedProviders,
      incidentId: this.incidentId
    } as SupplierDialogData;

    const matDialogRef = this.dialogViewerService.openSupplierSearchDialog(supplierDialogData);
    if (matDialogRef) {
      setTimeout(() => {
        this.dialogStateService.sendToFront(matDialogRef.id);
      }, 0);
      matDialogRef.afterClosed().pipe(take(1)).subscribe((result) => {
        if (!!supplierDialogData.caseStakeholderId) {
          this.serviceOrder.supplierId = supplierDialogData.caseStakeholderId;
          // returnedProviders are loaded py the parent component, so we need to wait for the changes to propagate
          this.returnedProvidersChanged.pipe(take(1)).subscribe(() => this.lookupCreditorCurrency());
          this.supplierAddedEvent.emit(supplierDialogData.caseStakeholderId);
          this.getAutoSuggestion(supplierDialogData.caseStakeholderId);
        }
      });
    }
  }

  lookupCreditorCurrency(){
    const provider = this.returnedProviders.find(provider => provider.id == this.serviceOrder.supplierId.toString());
    if (provider?.company?.providerId){
      this.supplierProfileService.getCreditorCurrency(Number(provider.company.providerId)).subscribe(
        result => {

          this.lookedUpCurrency = result;
          this.serviceOrder.exchangedCostCurrency = result;
          this.serviceOrder.exchangedCostValue = null;
          this.transferToExchange();
        }
      );
    }
  }

  transferToReserve(): void {
    if (!this.serviceOrder.exchangedCostCurrency || this.serviceOrder.exchangedCostCurrency === ''){
      return;
    }
    this.exchangeService.getExchangeRateNow(this.serviceOrder.exchangedCostCurrency, this.serviceOrder.expectedCostCurrency).subscribe(
      result => {
        this.serviceOrder.expectedCostValue = (parseFloat(this.serviceOrder.exchangedCostValue) * result.normalRate).toFixed(2);
        this.checkIfLeftSideIsValid();
      }
    );
  }

  reserveChanged(newValue: any): void {
    this.serviceOrder.expectedCostValue = newValue.toString();
    if (this._serviceOrder.expectedCostValue !== this._serviceOrder.suggestedCostValue &&
      this._serviceOrder.suggestedCostValue !== String(0)) {
      this._serviceOrder.autoSuggestionEnabled = false;
    }
    this.transferToExchange();
    this.checkIfLeftSideIsValid();
  }

  transferToExchange(): void {
    if (!this.serviceOrder.exchangedCostCurrency || this.serviceOrder.exchangedCostCurrency === ''){
      return;
    }
    this.exchangeService.getExchangeRateNow(this.serviceOrder.expectedCostCurrency, this.serviceOrder.exchangedCostCurrency).subscribe(
      result => {
        this.serviceOrder.exchangedCostValue = (parseFloat(this.serviceOrder.expectedCostValue) * result.normalRate).toFixed(2);
      }
    );
  }
  exchangedAmountChanged(newValue: any): void {
    this.serviceOrder.exchangedCostValue = newValue.toString();
    if ( this._serviceOrder.exchangedCostValue !== this._serviceOrder.suggestedCostValue ) {
      this._serviceOrder.autoSuggestionEnabled = false;
    }
    this.transferToReserve();
  }
  exchangedCurrencyChanged(): void {
    this.transferToExchange();
  }

  get PermissionEnum() {
    return PermissionEnum;
  }

  changeStatus(serviceOrderStatus: StatusTypes, event: any = null) {
    // Guard clauses - early returns
    debugger;
    if (serviceOrderStatus === this.serviceOrder.status && event != null) {
      return false;
    }
    if (this.serviceOrderTypeState.isConfirmationTabSaved && serviceOrderStatus === StatusTypes.EXPECTED) {
      return false;
    }

    // Clear commitment type if changing from EXPECTED and current type doesn't match available types
    if (this.serviceOrder.status === StatusTypes.EXPECTED &&
        this.serviceOrderType &&
        this.serviceOrder.extension.getCommitmentType() &&
        !this.serviceOrderType.commitmentTypes.
        some(obj => obj.businessKey === this.serviceOrder.extension.getCommitmentType().businessKey)) {
      this.serviceOrder.extension.setCommitmentType(null);
    }

    // Update status if it changed
    if (serviceOrderStatus !== this.serviceOrder.status) {
      this.serviceOrder.status = serviceOrderStatus;
      this.serviceOrderTypeState.statusChangeEvent.emit(serviceOrderStatus);
      if (serviceOrderStatus === StatusTypes.EXPECTED) {
        this.retrieveReserveSuggestion(this.returnedProviders.find(sh => +sh.id === this.serviceOrder.supplierId));
      }
    }

    if ([StatusTypes.COMMITTED, StatusTypes.CANCELLED].includes(serviceOrderStatus)) {
      this.serviceOrderTypeState.showConfirmationTab = true;
      this.serviceOrderTypeState.showDetailsTab = true;
    }

    // Update account GOP info for COMMITTED status when no commitment type and supplier exists
    if (serviceOrderStatus === StatusTypes.COMMITTED &&
        !this.serviceOrder.extension.getCommitmentType() &&
        this.serviceOrder.supplierId) {
      const stakeholder = this.returnedProviders.find(sh => +sh.id === this.serviceOrder.supplierId);
      this.accountGopService.updateAccountGopInfo(stakeholder?.company?.providerId ?? '0');
    }

    if (serviceOrderStatus === StatusTypes.EXPECTED) {
      this.serviceOrderTypeState.showConfirmationTab = false;
      this.serviceOrderTypeState.showDetailsTab = false;
    }

    // Reset reserve for CANCELLED or NOT_COVERED when service order is MEDICAL_ESCORT or TREATMENT
    if ([StatusTypes.CANCELLED, StatusTypes.NOT_COVERED].includes(serviceOrderStatus) &&
        [ServiceTypeEnum.MEDICAL_ESCORT, ServiceTypeEnum.TREATMENT].includes(this.serviceOrder.type)) {
      this.suggestedReserveValue = 0;
      this.serviceOrder.expectedCostValue = '0';
    }
  }

  expectedDisabled(): boolean {
    return this.expectedNotPossible ||
      this.isHomeAndPropertyServiceOrderType ||
      (this.selectedServiceOrderInitialStatus !== StatusTypes.EXPECTED &&
        this.selectedServiceOrderInitialStatus !== StatusTypes.NOT_COVERED);
  }

  notCoveredDisabled(): boolean {
    if (this.serviceOrder.coverageTypeId ===  DefaultCoveragesAlwaysPresentEnum.NOT_COVERED) {
      return false;
    } else {
      return (this.serviceOrder.status !== StatusTypes.EXPECTED &&  this.serviceOrder.status !== StatusTypes.NOT_COVERED);
    }
  }

  commitedDisabled(): boolean {
    return !this.isRegularFlightNonMedical && (!this.serviceOrderTypeState.isLeftSideValid || !this.isRightSideValid);
  }

  canceledDisabled(): boolean {
    return (
      !this.serviceOrderTypeState.isLeftSideValid ||
      !this.isRightSideValid ||
      this.selectedServiceOrderInitialStatus === StatusTypes.EXPECTED
    );
  }

  iccCommitedHover(): string {
    if (this.iccServiceOrder.status == StatusTypes.COMMITTED  && this.serviceOrder.status == StatusTypes.CANCELLED) {
      return null;
    } else {
      return 'coordination-linked-service-order-status-disabled-text';
    }
  }

  iccCanceledDisabled(): boolean {
    return this.selectedServiceOrderInitialStatus !== StatusTypes.COMMITTED;
  }

  iccCancelledHover(): string {
    if (this.serviceOrder.status == StatusTypes.CANCELLED ||
      (this.iccServiceOrder.status == StatusTypes.COMMITTED  &&
        this.serviceOrder.status == StatusTypes.COMMITTED)) {
      return null;
    } else {
      return 'coordination-linked-service-order-status-disabled-text';
    }
  }

  get isAmbulanceFlight(): boolean {
    return this.serviceOrder.type === ServiceTypeEnum.AMBULANCE_FLIGHT;
  }

  get isCommitted(): boolean {
    return this.serviceOrder.status === StatusTypes.COMMITTED;
  }

  get StatusTypes() {
    return StatusTypes;
  }

  get canceledWarningVisible(): boolean {
    return this.serviceOrder.status === StatusTypes.CANCELLED;
  }

  get notCoveredWarningVisible(): boolean {
    return this.serviceOrder.status === StatusTypes.NOT_COVERED;
  }

  sendSupplierInformation(stakeholderId: number): void {
    const message = new Message();
    message.templateType = 'CONTACT_INFO';
    message.messageChannelType = MessageChannelType.SMS;
    message.sms = new PhoneDto();
    message.selectedStakeholder = this.returnedProviders.find(cs => String(cs.id) === String(stakeholderId));
    message.caseId = '' + this.serviceOrder.caseId;
    const srMessage = new ServiceOrderMessageRequest({
      messageService: this.caseMessageService,
      message });
    const matDialogRef = this.dialogViewerService.openOutputManagementDialog(this.case, message.messageChannelType, srMessage, null);
    if ( matDialogRef ) {
      setTimeout(() => {
        this.dialogStateService.sendToFront(matDialogRef.id);
      }, 0);
    }
  }

  /**
   * Builds the reserve suggester line DTOs based on the service order type and its extension.
   * Returns an array of line DTOs for the reserve suggestion request.
   */
  private buildReserveSuggesterLineDtos(): any[] {
    if (this._serviceOrder.type === ServiceTypeEnum.TREATMENT) {
      const treatments = this.serviceOrder.extension as TreatmentServiceOrderExtension;
      return treatments.durations
        .filter(duration => duration.startDate && duration.endDate)
        .map(duration => {
          const durationInDays = duration.endDate.diff(duration.startDate, 'days') + 1;
          return {
            serviceType: this.serviceOrder.type,
            patientType: durationInDays > 1 ? PatientType.INPATIENT : PatientType.OUTPATIENT,
            quantity: durationInDays,
            unit: 'DAYS'
          };
        });
    } else if (this._serviceOrder.type === ServiceTypeEnum.MEDICAL_ESCORT) {
      const medicalEscort = this.serviceOrder.extension as MedicalEscortServiceOrderExtension;
      if (medicalEscort.duration?.startDate && medicalEscort.duration?.endDate) {
        const durationInDays = medicalEscort.duration.endDate.diff(medicalEscort.duration.startDate, 'days') + 1;
        return [{
          serviceType: this.serviceOrder.type,
          patientType: durationInDays > 1 ? PatientType.INPATIENT : PatientType.OUTPATIENT,
          quantity: durationInDays,
          unit: 'DAYS'
        }];
      }
      return [];
    }
    // Return empty array if not supported type
    return [];
  }

  autoSuggestionToggleChanged(caseStakeholderId: number): void {
    if (!this._serviceOrder.autoSuggestionEnabled) {
      this.serviceOrder.expectedCostValue = null;
      this.serviceOrder.exchangedCostValue = null;
      this.suggestedReserveValue = 0;
      this.checkIfLeftSideIsValid();
    } else {
      this.getAutoSuggestion(caseStakeholderId);
    }
  }

  getAutoSuggestion(signalChange: CommitmentType | CaseStakeholder | number): void {
    const requiredDataPresent =
      this.serviceOrder &&
      this.incident?.incidentLocation?.countryCodeAlpha2 &&
      Array.isArray(this.selectedStakeholders) &&
      this.selectedStakeholders.length > 0 &&
      this.case?.caseStakeholders &&
      this.caseNumber &&
      this.displayServiceOrderId;

    if (!requiredDataPresent) {
      console.warn('Missing required data for reserve suggestion.');
      return;
    }

    let commitmentTypeKey: string | undefined;
    if (signalChange instanceof CommitmentType) {
      // if the change comes from commitment type selection
      commitmentTypeKey = signalChange.businessKey;
      if (commitmentTypeKey === CommitmentTypes.EHIC_PARTIAL_GOP || commitmentTypeKey === CommitmentTypes.EHIC_FULL_COVERAGE) {
        this.suggestedReserveValue = 0;
        this.setReserveValue('0');
        return;
      }
    } else {
      commitmentTypeKey = this.serviceOrder.extension.getCommitmentType()?.businessKey;
      if (commitmentTypeKey === CommitmentTypes.EHIC_PARTIAL_GOP || commitmentTypeKey === CommitmentTypes.EHIC_FULL_COVERAGE)  {
        this.suggestedReserveValue = 0;
        this.setReserveValue('0');
        return;
      }
    }

    if (signalChange instanceof CaseStakeholder) {
      this.retrieveReserveSuggestion(signalChange);
    } else if (typeof signalChange === 'number') {
      this.caseService.getCaseStakeholder(this.caseId.toString(), signalChange.toString()).pipe(take(1)).subscribe(stakeholder => {
        this.retrieveReserveSuggestion(stakeholder);
      });
    } else {
      const stakeholder = this.returnedProviders.find(sh => +sh.id === this.serviceOrder.supplierId);
      this.retrieveReserveSuggestion(stakeholder);
    }
  }
  /**
   * Requests a reserve suggestion from the backend based on the current service order and case/incident context.
   */
  retrieveReserveSuggestion(caseStakeholder: CaseStakeholder | null): void {
    if (!this.reserveSuggestionFeatureEnabled) {
      this.suggestedReserveValue = 0;
      return;
    }
    const reserveSuggesterLineDtos = this.buildReserveSuggesterLineDtos();
    if (!reserveSuggesterLineDtos.length) {
      console.warn('No reserve suggester lines could be built for this service order type.');
      return;
    }
    const firstStakeholder = this.selectedStakeholders && this.selectedStakeholders.length > 0 ? this.selectedStakeholders[0] : undefined;
    const reserveSuggesterDto: ReserveSuggesterDto = {
      reserveSuggesterLineDtos,
      incidentCode: {
        causeLevel3: this.incident.causeLevel3Code
      },
      country: this.incident.incidentLocation?.countryCodeAlpha2 || 'Unknown',
      icd10Code: this.incident.diagnosis?.icd10Code || 'Unknown',
      age: firstStakeholder?.person?.age || 0,
      gender: firstStakeholder?.person?.gender || 'Unknown',
      supplierId: caseStakeholder?.company.providerId || 'Unknown',
      caseNumber: this.caseNumber || 'Unknown',
      serviceOrderId: this.displayServiceOrderId || 'Unknown'
    };

    this.suggestionService.reserveSuggestion(reserveSuggesterDto)
      .pipe(take(1))
      .subscribe({
        next: (value: ReserveSuggestionResponseDto) => {
          this.handleReserveSuggestionResponse(value); },
        error: (error) => {
          console.error('Error occurred while retrieving reserve suggestion:', error);
          this.handleReserveSuggestionError(error); }
      });
  }

  /**
   * Handles the response from the reserve suggestion request.
   * Subscribes to the result event stream and updates the suggested reserve value.
   * Handles unexpected or invalid results gracefully.
   */
  private handleReserveSuggestionResponse(response: ReserveSuggestionResponseDto): void {
    if (!response || !response.sseId) {
      this.suggestedReserveValue = 0;
      console.error('Invalid reserve suggestion response:', response);
      return;
    }

    const reserveEstimate = this.suggestionService.reserveSuggestionResult(response.sseId).pipe(take(1));// take(1) sikrer, at vi kun får et enkelt svar og derefter afslutter subscriptionen
    const medicalEscortFee = this.buildMedicalEscortFeeRequest();

    forkJoin({ reserveEstimate, medicalEscortFee })
      .subscribe({
        next: ({ reserveEstimate, medicalEscortFee }) => {
          // Try to parse the result as a number
          const parsedValue = Number(reserveEstimate);
          this.serviceOrder.suggestedCostValue = reserveEstimate;
          if (isNaN(parsedValue)) {
            console.error('Reserve suggestion result is not a valid number:', reserveEstimate);
            this.suggestedReserveValue = 0;
          } else {
            this.suggestedReserveValue = parsedValue + medicalEscortFee.amount;
            this.insertSuggestion();
          }
        },
        error: (error) => this.handleReserveSuggestionError(error)
      });
  }

  private buildMedicalEscortFeeRequest(): Observable<MedicalEscortFeeResponseDto> {
    if (this.serviceOrder.type === ServiceTypeEnum.MEDICAL_ESCORT &&
      this.serviceOrder.extension.getCommitmentType()?.businessKey
    ) {
      return this.customerProfileInfo$.pipe(
        switchMap(customerProfile => {
          console.log('customer profile id' + customerProfile?.customerProfileId);
        const medicalEscortFeeRequest = {
          customerProfileId: customerProfile.customerProfileId,
          caseType: this.case.caseTypeCode,
          caseCreationDate: this.case.caseCreatedDate ? this.case.caseCreatedDate : new Date(),
          commitmentType: this.serviceOrder.extension.getCommitmentType()?.businessKey || '',
          causeLevel1Code: this.incident.causeLevel1Code,
          causeLevel2Code: this.incident.causeLevel2Code,
          medicalEscortStart: this.serviceOrder.extension.getStartDate().toDate(),
          medicalEscortEnd: this.serviceOrder.extension.getEndDate().toDate()
        };
        return this.medicalEscortFeeService.calculateMedicalEscortFee(medicalEscortFeeRequest);
      }))
    }
    return of({amount: 0, currency: null} as MedicalEscortFeeResponseDto);
  }

  private handleReserveSuggestionError(error: any): void {
    console.error('Failed to retrieve reserve suggestion:', error);
  }

  private setReserveValue(value: string) {
    if (this.serviceOrder.expectedCostCurrency !== 'DKK') {
      this.exchangeService.getExchangeRateNow('DKK', this.serviceOrder.expectedCostCurrency)
        .pipe(take(1))
        .subscribe({
          next: (result) => {
            const exchangedValue = (this.suggestedReserveValue * result.normalRate).toFixed(2);
            this.serviceOrder.expectedCostValue = exchangedValue;
            this.reserveChanged(exchangedValue);
            this._serviceOrder.autoSuggestionEnabled = true;
          },
          error: (err) => {
            console.error('Failed to get exchange rate:', err);
            this.serviceOrder.expectedCostValue = value;
            this.reserveChanged(value);
            this._serviceOrder.autoSuggestionEnabled = false;
          }
        });
    } else {
      this.serviceOrder.expectedCostValue = value;
      this.reserveChanged(value);
    }
  }

  protected insertSuggestion() {
    if (this.serviceOrder.autoSuggestionEnabled || this.serviceOrder.type === ServiceTypeEnum.MEDICAL_ESCORT) {
      this.setReserveValue(this.suggestedReserveValue.toString());
    }
  }
}
